var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListForSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/list-for-sale") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,1.5 C12.7652165,1.5 13.0195704,1.60535684 13.2071068,1.79289322 L21.7992073,10.385 C22.9623781,11.5551124 22.9623781,13.4448876 21.7992073,14.615 L14.6275,21.7867133 C14.0647952,22.3500445 13.3012277,22.6665733 12.505,22.6665733 C11.7087723,22.6665733 10.9452048,22.3500445 10.3833052,21.7875185 L1.79330517,13.2075185 C1.6055168,13.0199487 1.5,12.7654183 1.5,12.5 L1.5,2.5 C1.5,1.94771525 1.94771525,1.5 2.5,1.5 L12.5,1.5 Z M12.085,3.5 L3.5,3.5 L3.5,12.086 L11.7975,20.3732867 C11.9538069,20.5297675 12.1566098,20.6291182 12.3734622,20.6578884 L12.505,20.6665733 C12.7704092,20.6665733 13.0249317,20.5610637 13.2128932,20.3728932 L20.3828932,13.2028932 C20.7685163,12.8149625 20.7685163,12.1850375 20.3828932,11.7971068 L12.085,3.5 Z M7.51,6.5 C8.06228475,6.5 8.51,6.94771525 8.51,7.5 C8.51,8.05228475 8.06228475,8.5 7.51,8.5 C6.94771525,8.5 6.5,8.05228475 6.5,7.5 C6.5,6.94771525 6.94771525,6.5 7.5,6.5 L7.51,6.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/list-for-sale",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -0.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListForSale);
export default __webpack_public_path__ + "static/media/list-for-sale.1423ca056a7ec64fd02b7e7cdd5db9d0.svg";
export { ForwardRef as ReactComponent };